import React, { Component } from "react";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import configData from "../config.json";
import "./Abha.css";

export default class ExistingAbha extends Component {
  constructor(props) {
    super(props);
    this.state = {
      requestId: sessionStorage.getItem("requestId"),
      AbhaProfile: {},
      abhanumber: "",
      aadharNumber: "",
      phrAddress: "",
    };
  }
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg); // 'warn' is used instead of 'warning'
        break;
      default:
        toast.info(msg);
    }
  };
  componentDidMount() {
    this.ResponseHandler();
  }
  ResponseHandler = () => {
    var formData = new FormData();

    formData.append("requestId", this.state.requestId);
    fetch(configData.api_url + "C_Abhadetails/retriverequestId", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success" && data.detail) {
          const abhaDetails = JSON.parse(data.detail.abhaprofile);
          // console.log(abhaDetails);
          const abhaProfile = abhaDetails.ABHAProfile;
          const abhanumber = data.detail.abhanumber;
          const phrAddress = data.detail.phrAddress;
          if (abhaProfile) {
            sessionStorage.setItem("abhaProfileStatus", "success");
            this.setState({
              AbhaProfile: abhaProfile,
              abhanumber: abhanumber,
              phrAddress: phrAddress,
            });
          } else {
            sessionStorage.setItem("abhaProfileStatus", "fail");
            window.location = "/consent";
          }
        }
      });
  };
  HandleClick = () => {
    const { abhaAddress, aadharNumber, abhanumber } = this.state;
    sessionStorage.setItem("abhaAddress", abhaAddress);
    sessionStorage.setItem("aadharNumber", aadharNumber);
    sessionStorage.setItem("abhanumber", abhanumber);

    window.location.href = "/abhaaddresscreation";
  };
  handlenextClick = () => {
    const { abhanumber, aadharNumber } = this.state;
    const formData = new FormData();
    formData.append("requestId", this.state.requestId);
    fetch(configData.api_url + "C_Abhadetails/getAbhaProfile", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        sessionStorage.setItem("abhaAddress", this.state.phrAddress);
        sessionStorage.setItem("aadharNumber", aadharNumber);
        sessionStorage.setItem("abhanumber", abhanumber);
        this.showToast(data.message);

        if (data.status === "success") {
          window.location.href = "/abhaprofile";
        }
      });
  };

  handlenewClick = () => {
    sessionStorage.setItem("abhaAddress", this.state.AbhaProfile.phrAddress);
    window.location = "./abhaaddresschange";
  };
  render() {
    return (
      <div>
        <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>
          Existing-ABHA
        </h3>
        <div className="row  widget_BG mt-2 existingabha">
          <div className="col-md-4">
            <Form.Group>
              <Form.Label>
                <b>Abha Number</b>
              </Form.Label>

              <div ClassName="custom-calendar">
                <Form.Control
                  type="text"
                  name="abhanumber"
                  id="abhanumber"
                  value={this.state.abhanumber}
                  disabled
                  className="form-control"
                />
              </div>
            </Form.Group>
          </div>
          <div className="col-md-4">
            <Form.Label>
              <b>Abha Address</b>
            </Form.Label>
            <div ClassName="custom-calendar">
              <Form.Control
                type="text"
                name="phrAddress"
                id="phrAddress"
                value={this.state.phrAddress}
                disabled
                className="form-control"
              />
            </div>
          </div>
          <div className="col-md-4 text-end">
            <br />
            <Button className="rounded-0 m-1" onClick={this.handlenewClick}>
              New ABHA Address
            </Button>
            <Button className="rounded-0 m-1" onClick={this.handlenextClick}>
              ABHA Profile
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
